export const zar = (v) =>
  new Intl.NumberFormat("en-ZA", { style: "currency", currency: "ZAR" }).format(Number(v) || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = iso.length === 10 ? new Date(iso + "T00:00:00") : new Date(iso);
  return d.toLocaleDateString("en-ZA", { day: "numeric", month: "short", year: "numeric" });
};

export const fmtDayShort = (iso) => {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-ZA", { weekday: "short", day: "numeric", month: "short" });
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.toLocaleDateString("en-ZA", { day: "numeric", month: "short" })} ${d.toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" })}`;
};

export const TIP_CATEGORY_LABELS = {
  foh_senior: "FOH Senior",
  foh_junior: "FOH Junior",
  kitchen_senior: "Kitchen Senior",
  kitchen_junior: "Kitchen Junior",
  scullery: "Scullery",
  reservations: "Reservations",
};

export const FLAG_LABELS = {
  auto_clockout: "Auto clock-out",
  missed_clockout: "Missed clock-out",
  over_roster: "Over roster",
  public_holiday: "Public holiday",
  no_show: "No show",
  over_9h_day: ">9h day",
  over_45h_week: ">45h week",
  phone_no_gps: "Phone · no GPS",
};
